import React, {useEffect, useState, useRef} from 'react';
import {useHistory} from 'react-router-dom'
import {Input,Form} from '../../styles/CommonStyles';
import {DivInput,
    DivPrincipal,
    DivHeader,
    TituloConfiguracao,
    DivTituloConfiguracao,
    DivImgEButton,
    DivImgLogoPerfil,
    IconFcInfo,
    ButtonHide,
    ImgPaginasBlog,
    ImgLogo,
    ImgLogoMobile,
    IconGrView,} from './profileStyled';
import InputFile from '../../components/inputs/inputFile/InputFile';
import {Button,SpanButton} from '../postEdit/stylePostEdit';
import Toastify from '../../components/Toastify/index';
import {GetCurrentUser} from '../../services/servicesGetCurrentUser';
import { IsBlogUnique } from '../../services/servicesIsBlogUnique';
import { CreateBlogDirectory } from '../../services/servicesCreateBlogDirectory';
import {SaveMyProfile} from '../../services/servicesPostSaveMyProfile';
import {URLIMG} from '../../helpers/constantes';
import LoadScreen from '../../components/loadScreen/loadScreen';
import LoadScreenSmall from '../../components/loadScreenSmall/loadScreenSmall';
import ButtonTrialVersion from '../../components/ButtonTrialVersion/ButtonTrialVersion';
import Tooltip from '../../components/tooltip/Tooltip';

export default function Profile(){
    const svgNoImage = require('../../assets/svgs/data-not-found.svg').default;
    const[dadosPerfil, setDadosPerfil] = useState({});
    const[perfil, setPerfil] = useState(true);
    const[logoHeader, setLogoHeader] = useState(true);
    const[apresentacao, setApresentacao] = useState(true);
    const[menu1, setMenu1] = useState(true);
    const[menu2, setMenu2] = useState(true);
    const[headerPerfil, setHeaderPerfil] = useState(true);
    const[mobileHeaderPerfil, setMobileHeaderPerfil] = useState(true);
    const scrollRef = useRef();
    const refInitialPage = useRef();
    const refFirstPage = useRef();
    const refSecondPage = useRef();
    const refProfileInfo = useRef();
    const [showButtonPreview, setShowButtonPreview] = useState(false);
    const [previewField, setPreviewField] = useState('');
    const [mostraBotao, setMostraBotao] = useState(false);
    const [pathName, setPathName] = useState('')
    const [loadSmall, setLoadSmall] = useState(false);
    const history = useHistory();
    async function carregaDadosPerfil(){
        try {
            const dadosPerfilCarregados = await GetCurrentUser();
            setDadosPerfil({...dadosPerfil,
                Nome:dadosPerfilCarregados.Name,
                Email:dadosPerfilCarregados.Email,
                NomeBlog:dadosPerfilCarregados.AliasName,
                EnderecoBlog:dadosPerfilCarregados.AliasName.split(' ').toString().replace(/,/g,'').normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9 ]/g, "").toLowerCase(),
                FanpageFacebook:dadosPerfilCarregados.Facebook,
                Instagram:dadosPerfilCarregados.Instagram,
                Youtube:dadosPerfilCarregados.Youtube,
                Cover:dadosPerfilCarregados.Cover,
                EmailConsultorio:dadosPerfilCarregados.Email,
                Telefone:dadosPerfilCarregados.OfficePhone1,
                Telefone2:dadosPerfilCarregados.OfficePhone2,
                PalavraGoogle:dadosPerfilCarregados.Keywords,
                Curriculo:dadosPerfilCarregados.ResumeText,
                Image1:dadosPerfilCarregados.Picture,
                DescriptionWelcome:dadosPerfilCarregados.DescriptionWelcome,
                DescriptionPage1:dadosPerfilCarregados.DescriptionPage1,//.replace(/\<br\/>/g,/\n/),
                DescriptionPage2:dadosPerfilCarregados.DescriptionPage2,//.replace(/\<br\/>/g,/\n/),
                Menu1:dadosPerfilCarregados.Menu1,
                Menu2:dadosPerfilCarregados.Menu2,
                SliderCaption1:dadosPerfilCarregados.SliderCaption1,
                SliderCaption2:dadosPerfilCarregados.SliderCaption2,
                SliderCaption3:dadosPerfilCarregados.SliderCaption3,
                SliderDescription1:dadosPerfilCarregados.SliderDescription1,
                SliderDescription2:dadosPerfilCarregados.SliderDescription2,
                SliderDescription3:dadosPerfilCarregados.SliderDescription3,
                SliderPicture1:dadosPerfilCarregados.SliderPicture1,
                SliderPicture2:dadosPerfilCarregados.SliderPicture2,
                SliderPicture3:dadosPerfilCarregados.SliderPicture3,
                LogoHeader:dadosPerfilCarregados.LogoHeader,
                LogoMobile:dadosPerfilCarregados.LogoMobile,
                City1:dadosPerfilCarregados.City1,
                City2:dadosPerfilCarregados.City2,
                Address1:dadosPerfilCarregados.Address1,
                Address2:dadosPerfilCarregados.Address2,
                AnalyticsCode:dadosPerfilCarregados.AnalyticsCode,
                Description:dadosPerfilCarregados.Description,
                NewsLetterLink:dadosPerfilCarregados.NewsLetterLink
            })
        } catch (error) {
            Toastify.error('Não foi possível acessar os dados de perfil');
        }

    }
   async function enviaDados(event){
        event.preventDefault();
        setLoadSmall(true);
        if(dadosPerfil.Nome !== ''){
            if(dadosPerfil.Email !==''){
                if(dadosPerfil.NomeBlog !== ''){
                    const blogUnico = await IsBlogUnique(dadosPerfil.EnderecoBlog);
                    if(blogUnico){
                        const criandoFolder = await CreateBlogDirectory(dadosPerfil.EnderecoBlog);
                        if(criandoFolder.data === "Success" && criandoFolder.status === 200){
                            const salvamento = await   SaveMyProfile(dadosPerfil);
                            if (salvamento.status !== 400){
                                localStorage.setItem('currentUser',JSON.stringify(dadosPerfil));
                                setLoadSmall(false);
                                Toastify.success('Dados salvos com sucesso');
                            }else{
                                setLoadSmall(false);
                                Toastify.error('Não foi possível salvar');
                            }
                        }else{
                            setLoadSmall(false);
                            Toastify.error('Erro ao salvar os dados de perfil')
                        }
                    }else{
                        setLoadSmall(false);
                        Toastify.error('Nome de blog já utilizado');
                    }
                }else{
                    setLoadSmall(false);
                    Toastify.warning('Prencha o campo Nome do blog, por favor!');
                }
            }else{
                setLoadSmall(false);
                Toastify.warning('Prencha o campo e-mail, por favor!');
            }
        }else{
            setLoadSmall(false);
            Toastify.warning('Prencha o campo nome, por favor!');
        }
    }
    function AlteraNomeDoBlog(string){
        setDadosPerfil({
            ...dadosPerfil,
            NomeBlog:string,
            EnderecoBlog:string.
                split(' ').
                toString().
                replace(/,/g,'').
                normalize('NFD').
                replace(/[\u0300-\u036f]/g, "").
                replace(/[^a-zA-Z0-9 ]/g, "").
                toLowerCase()
        });
    }
    function loadSVG(event){
        event.preventDefault();
        event.currentTarget.src = svgNoImage;

    }
    function MostraBotao(){
        if(scrollRef.current.scrollTop > refInitialPage.current.offsetTop - 60  ){
            setShowButtonPreview(true);
            setPathName('index.html');
            setPreviewField('visualizar pagina inicial');
            if(scrollRef.current.scrollTop  > refFirstPage.current.offsetTop - 60){
                setPreviewField('visualizar primeira página');
                setPathName('pagina1.html')
            }
            if(scrollRef.current.scrollTop   > refSecondPage.current.offsetTop - 60){
                setPreviewField('visualizar segunda página');
                setPathName('pagina2.html')
            }
            if(scrollRef.current.scrollTop  > refProfileInfo.current.offsetTop - 60){
                setPreviewField('visualizar página de perfil');
                setPathName('sobremim.html')
            }


        }else{
            setShowButtonPreview(false);

        }


    }
    useEffect(()=>{
        carregaDadosPerfil();
},[]);
    return(<DivPrincipal  ref={scrollRef} onScroll={MostraBotao}>
            <ButtonTrialVersion />
            <a target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}/${pathName}`}>
                <ButtonHide style={{right:window.screen.width < 800?'180px':'250px', width:'unset'}} display={showButtonPreview?'block':'none'} >
                    <SpanButton>{previewField}</SpanButton>
                </ButtonHide>
            </a>
            <ButtonHide display={'block'} onClick={(event)=>enviaDados(event)} >
                <SpanButton>Salvar Alterações</SpanButton>
            </ButtonHide>
            <Form>
                <DivHeader ref={scrollRef} onScroll={MostraBotao}  >
                    <div >
                        {perfil ?
                            <img style={{width:'230px', height:'230px'}} onError={(event)=>loadSVG(event)}
                                src={URLIMG+dadosPerfil?.Image1?.split('/')[dadosPerfil.Image1.split('/').length - 1] || svgNoImage}
                                alt=''
                            />
                        :
                            <div style={{width:'100%',height:'100%'}}>
                                <LoadScreen position='unset'/>
                                </div>
                        }
                        <InputFile onClick={(event)=>enviaDados(event)}
                            mudaImg={setDadosPerfil}
                            imagem={dadosPerfil}
                            campo='Image1'
                            load={perfil}
                            concluido={setPerfil} />
                    </div>
                    <div style={{width:'100%',marginLeft:'10px'}}>
                        <DivInput style={{width:'100%',margin:'0'}}>
                            <p>Nome *</p>
                            <Input placeholder='Informe o seu nome' value={dadosPerfil.Nome || ''} onChange={({target})=>{setDadosPerfil({...dadosPerfil,Nome:target.value})}}/>
                        </DivInput>
                        <DivInput style={{width:'100%',margin:'0'}}>
                            <p>E-mail *</p>
                            <Input placeholder='Informe o seu e-mail' value={dadosPerfil.Email || ''} onChange={({target})=>{setDadosPerfil({...dadosPerfil,Email:target.value})}} />
                        </DivInput>
                        <DivInput style={{width:'100%',margin:'0'}}>
                            <p>Nome para o seu site que será criado pelo MEDX social*</p>
                            <Input placeholder='Dê um nome para o seu blog' value={dadosPerfil.NomeBlog || ''} onChange={({target})=>{AlteraNomeDoBlog(target.value)}} />
                        </DivInput>
                        <DivInput style={{width:'100%',margin:'0'}}>
                            <p>Endereço do seu site que será gerado pelo MEDX Social</p>
                            <div style={{overflow:'hidden',width:'100%',backgroundColor:'lightgray', height:'40px',display:'flex', alignItems:'center', padding:'5px 10px', borderRadius:'4px'}}>
                                <a target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}`}>{`https://social.medx.med.br/${dadosPerfil.EnderecoBlog}`}</a>
                            </div>
                        </DivInput>
                        </div>
                    </DivHeader>
                    <DivInput style={{width:'100%',textAlign:'center'}}>
                        <p>Insira sua logo (1000px largura x 200px altura)</p>
                        <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', margin:'10px 0px 0px 0px'}} >
                            {logoHeader ?
                                <ImgLogo onError={(event)=>loadSVG(event)}
                                    src={URLIMG+dadosPerfil?.LogoHeader?.split('/')[dadosPerfil.LogoHeader.split('/').length - 1] || svgNoImage}
                                    alt=''
                                />
                            :
                                <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                            }
                            <InputFile name='Insira sua logo'
                                onClick={(event)=>enviaDados(event)}
                                mudaImg={setDadosPerfil}
                                imagem={dadosPerfil}
                                campo='LogoHeader'
                                load={logoHeader}
                                concluido={setLogoHeader}

                            />
                        </div>
                    </DivInput>
                    <DivInput style={{width:'100%',textAlign:'center'}}>
                        <p>Insira sua logo versão mobile (smartphone) (240px largura x 70px altura)</p>
                        <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', margin:'10px 0px 0px 0px'}} >
                            {mobileHeaderPerfil ?
                                <ImgLogoMobile onError={(event)=>loadSVG(event)}
                                    src={URLIMG+dadosPerfil?.LogoMobile?.split('/')[dadosPerfil.LogoMobile.split('/').length - 1]?
                                        URLIMG+dadosPerfil?.LogoMobile?.split('/')[dadosPerfil.LogoMobile.split('/').length - 1]
                                    :
                                        svgNoImage}
                                    alt=''
                                />
                            :
                                <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                            }
                            <InputFile name='Inserir logo mobile'
                                onClick={(event)=>enviaDados(event)}
                                mudaImg={setDadosPerfil}
                                imagem={dadosPerfil}
                                campo='LogoMobile'
                                load={mobileHeaderPerfil}
                                concluido={setMobileHeaderPerfil}
                            />
                        </div>
                    </DivInput>
                    <DivInput>
                        <p>Sua Fanpage no facebook</p>
                        <Input placeholder='Insira o link de acesso a sua fanpage do Facebook'
                            defaultValue={dadosPerfil.FanpageFacebook}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,FanpageFacebook:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Seu Instagram</p>
                        <Input placeholder='Insira o link de acesso ao seu Instagram'
                            defaultValue={dadosPerfil.Instagram}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Instagram:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Seu Canal no YouTube</p>
                        <Input placeholder='Insira o link para acesso do seu canal no YouTube'
                            defaultValue={dadosPerfil.Youtube}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Youtube:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>E-mail do Consultório</p>
                        <Input placeholder='Insira um e-mail para contato do consultório'
                            defaultValue={dadosPerfil.EmailConsultorio}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,EmailConsultorio:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Cidade Consultório</p>
                        <Input placeholder='Insira a cidade do consultório'
                            defaultValue={dadosPerfil.City1}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,City1:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Endereço Consultório</p>
                        <Input placeholder='Insira o endereço do consultório'
                            defaultValue={dadosPerfil.Address1}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Address1:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Cidade Consultório2</p>
                        <Input placeholder='Insira a cidade do consultório'
                            defaultValue={dadosPerfil.City2}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,City2:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Endereço Consultório2</p>
                        <Input placeholder='Insira um e-mail para contato do consultório'
                            defaultValue={dadosPerfil.Address2}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Address2:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Whatsapp do Consultório</p>
                        <Input placeholder='Insira um telefone para o whatsapp do consultório'
                            defaultValue={dadosPerfil.Telefone}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Telefone:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Telefone do Consultório</p>
                        <Input placeholder='Insira um telefone para contato do consultório'
                            defaultValue={dadosPerfil.Telefone2}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Telefone2:target.value})}}
                        />
                    </DivInput>


                    <DivInput>
                        <p>Link para integração do seu newsletter</p>
                        <Input  placeholder='Insira o código para o seu NewsLetter'
                            defaultValue={dadosPerfil.NewsLetterLink}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,NewsLetterLink:target.value})}}
                        />
                    </DivInput>                    
                    <DivTituloConfiguracao >
                        <TituloConfiguracao style={{display:'flex', alignItems:'center'}}>
                            Configurações de SEO do site
                            <IconFcInfo data-tip data-for="infoSEO" />
                        </TituloConfiguracao>
                    </DivTituloConfiguracao>
                    <DivInput>
                        <p>Palavras-chave para buscadores (Google)</p>
                        <Input  placeholder='Insira as palavras para otimzar a busca do Google'
                            defaultValue={dadosPerfil.PalavraGoogle}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,PalavraGoogle:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Analitycs</p>
                        <Input placeholder='Insira o codigo do Google Analitycs'
                            defaultValue={dadosPerfil.AnalyticsCode}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,AnalyticsCode:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Descrição do blog</p>
                        <Input placeholder='Insira uma descrição do blog para otimizar a busca do google'
                            defaultValue={dadosPerfil.Description}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Description:target.value})}}
                        />
                    </DivInput>
                    <DivTituloConfiguracao >
                        <TituloConfiguracao ref={refInitialPage}>
                            Configurações da pagina início <a data-tip data-for="index" target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}/index.html`}><IconGrView/></a>
                        </TituloConfiguracao>
                    </DivTituloConfiguracao>
                    <DivInput>
                        <p>Titulo de Apresentação</p>
                        <Input  placeholder='Insira um titulo para apresentação do seu blog'
                            defaultValue={dadosPerfil.SliderCaption1}
                            maxLength="50"
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderCaption1:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Breve Descrição</p>
                        <Input  placeholder='Insira um breve texto para apresentação do seu site'
                            maxLength="150"
                            defaultValue={dadosPerfil.SliderDescription1}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderDescription1:target.value})}}
                        />
                    </DivInput>
                    <DivInput style={{width:'100%'}}>
                        <p>Texto de apresentação</p>
                        <textarea placeholder='Insira um texto para apresentação do seu blog'
                            value={dadosPerfil.DescriptionWelcome}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,DescriptionWelcome:target.value})}}
                        />
                    </DivInput>
                    <DivImgEButton>
                        <DivInput>
                            <p>Insira uma imagem para a apresentação do seu blog (1900px largura x 550px altura)</p>
                        </DivInput>
                        {apresentacao ?
                            <ImgPaginasBlog  onError={(event)=>loadSVG(event)} src={URLIMG+dadosPerfil?.SliderPicture1?.split('/')[dadosPerfil.SliderPicture1.split('/').length - 1]?URLIMG+dadosPerfil?.SliderPicture1?.split('/')[dadosPerfil.SliderPicture1.split('/').length - 1] : svgNoImage } alt=''/>
                        :
                            <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                        }


                        <InputFile onClick={(event)=>enviaDados(event)}
                            mudaImg={setDadosPerfil}
                            imagem={dadosPerfil}
                            campo='SliderPicture1'
                            load={apresentacao}
                            concluido={setApresentacao}
                            name='Inserir imagem'
                        />

                    </DivImgEButton>

                    <DivTituloConfiguracao>
                        <TituloConfiguracao ref={refFirstPage}>
                            Configurações da primeira página <a data-tip data-for="pagina1" target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}/pagina1.html`}><IconGrView/></a>
                        </TituloConfiguracao>
                    </DivTituloConfiguracao>
                    <DivInput>
                        <p>Nome para aparecer no menu</p>
                        <Input maxLength="50" placeholder='Insira um titulo para apresentação do seu blog' defaultValue={dadosPerfil.SliderCaption2} onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderCaption2:target.value})}} />
                    </DivInput>
                    <DivInput>
                        <p>Breve descrição da primeira página</p>
                        <Input maxLength="150" placeholder='Insira um breve texto para apresentação do seu blog' defaultValue={dadosPerfil.SliderDescription2} onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderDescription2:target.value})}} />
                    </DivInput>
                    <DivInput style={{width:'100%'}}>
                        <p>Texto da primeira página</p>
                        <textarea placeholder='Insira um texto para primeira página do seu site'
                            value={dadosPerfil.DescriptionPage1}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,DescriptionPage1:target.value})}}
                        />
                    </DivInput>
                    <DivImgEButton>
                        <DivInput>
                                <p>Insira uma imagem para a primeira página do seu site (1900px largura x 550px altura)</p>
                        </DivInput>
                        {menu1?
                            <ImgPaginasBlog  onError={(event)=>loadSVG(event)} src={URLIMG+dadosPerfil?.SliderPicture2?.split('/')[dadosPerfil.SliderPicture2.split('/').length -1]?URLIMG+dadosPerfil?.SliderPicture2?.split('/')[dadosPerfil.SliderPicture2.split('/').length -1]:svgNoImage} alt=''/>
                        :
                            <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                        }
                        <InputFile onClick={(event)=>enviaDados(event)}
                            mudaImg={setDadosPerfil}
                            imagem={dadosPerfil}
                            campo='SliderPicture2'
                            load={menu1}
                            concluido={setMenu1}
                            name='Inserir imagem'
                            />
                    </DivImgEButton>
                    <DivTituloConfiguracao>
                        <TituloConfiguracao ref={refSecondPage}>
                                Configurações da segunda página do blog <a data-tip data-for="pagina2" target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}/pagina2.html`}><IconGrView/></a>
                        </TituloConfiguracao>
                    </DivTituloConfiguracao>
                    <DivInput>
                        <p>Nome para aparecer no menu</p>
                        <Input maxLength="50" placeholder='Insira um titulo para apresentação do seu blog' defaultValue={dadosPerfil.SliderCaption3} onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderCaption3:target.value})}} />
                    </DivInput>
                    <DivInput>
                        <p>Breve descrição da segunda página</p>
                        <Input  maxLength="150" placeholder='Insira um breve texto para apresentação do seu blog' defaultValue={dadosPerfil.SliderDescription3} onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderDescription3:target.value})}} />
                    </DivInput>
                    <DivInput style={{width:'100%'}}>
                        <p>Texto da segunda página</p>
                        <textarea placeholder='Insira um texto para segunda página do seu site'
                            value={dadosPerfil.DescriptionPage2}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,DescriptionPage2:target.value})}}
                        />
                    </DivInput>
                    <DivImgEButton>
                        <DivInput>
                                <p>Insira uma imagem para a segunda página do seu site (1900px largura x 550px altura)</p>
                        </DivInput>
                        {menu2?
                            <ImgPaginasBlog  onError={(event)=>loadSVG(event)} src={URLIMG+dadosPerfil?.SliderPicture3?.split('/')[dadosPerfil.SliderPicture3.split('/').length - 1]?URLIMG+dadosPerfil?.SliderPicture3?.split('/')[dadosPerfil.SliderPicture3.split('/').length - 1]:svgNoImage} alt=''/>
                        :
                            <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                        }
                        <InputFile onClick={(event)=>enviaDados(event)}
                            mudaImg={setDadosPerfil}
                            imagem={dadosPerfil}
                            campo='SliderPicture3'
                            load={menu2}
                            concluido={setMenu2}
                            name='Inserir imagem'
                        />
                    </DivImgEButton>
                    <DivTituloConfiguracao>
                        <TituloConfiguracao ref={refProfileInfo}>
                                Configurações informações de perfil <a data-tip data-for="sobremim" target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}/sobremim.html`}><IconGrView/></a>
                        </TituloConfiguracao>
                    </DivTituloConfiguracao>
                    <DivInput style={{width:'100%'}}>
                        <p>Seu curriculo (página sobre mim) </p>
                        <textarea value={dadosPerfil.Curriculo} onChange={({target})=>{setDadosPerfil({...dadosPerfil,Curriculo:target.value})}} />
                    </DivInput>
                    <DivImgEButton>
                        <DivInput>
                                <p>Inserir uma capa para página de perfil (1200px largura x 500px altura)</p>
                        </DivInput>
                        {headerPerfil?
                            <DivImgLogoPerfil  onError={(event)=>loadSVG(event)} src={URLIMG+dadosPerfil?.Cover?.split('/')[dadosPerfil.Cover.split('/').length - 1]?URLIMG+dadosPerfil?.Cover?.split('/')[dadosPerfil.Cover.split('/').length - 1]:svgNoImage} alt=''/>
                        :
                            <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                        }
                        <InputFile onClick={(event)=>enviaDados(event)}
                            mudaImg={setDadosPerfil}
                            imagem={dadosPerfil}
                            campo='Cover'
                            load={headerPerfil}
                            concluido={setHeaderPerfil}
                            name='Inserir imagem'
                            />
                    </DivImgEButton>
                </Form>
            {
                loadSmall ? <LoadScreenSmall open= {loadSmall} close={setLoadSmall} /> : <></>
            }
            <Tooltip dataFor='infoSEO' mensagem='SEO é o conjunto de estratégias com o objetivo de potencializar e melhorar o posicionamento do seu site quando utilizam um buscador, como o Google por exemplo' />
            <Tooltip dataFor='index' mensagem='Clique aqui para visualizar a como estão as alterações da página inicial' />
            <Tooltip dataFor='pagina1' mensagem='Clique aqui para visualizar a como estão as alterações da primeira página' />
            <Tooltip dataFor='pagina2' mensagem='Clique aqui para visualizar a como estão as alterações da segunda inicial' />
            <Tooltip dataFor='sobremim' mensagem='Clique aqui para visualizar a como estão as alterações da página do seu perfil' />
        </DivPrincipal>)
}


{/*

    <Form>
                <DivHeader ref={scrollRef} onScroll={MostraBotao}  >
                    <div >
                        {perfil ?
                            <img style={{width:'230px', height:'230px'}} onError={(event)=>loadSVG(event)}
                                src={URLIMG+dadosPerfil?.Image1?.split('/')[dadosPerfil.Image1.split('/').length - 1] || svgNoImage}
                                alt=''
                            />
                        :
                            <div style={{width:'100%',height:'100%'}}>
                                <LoadScreen position='unset'/>
                                </div>
                        }
                        <InputFile onClick={(event)=>enviaDados(event)}
                            mudaImg={setDadosPerfil}
                            imagem={dadosPerfil}
                            campo='Image1'
                            load={perfil}
                            concluido={setPerfil} />
                    </div>
                    <div style={{width:'100%',marginLeft:'10px'}}>
                        <DivInput style={{width:'100%',margin:'0'}}>
                            <p>Nome *</p>
                            <Input placeholder='Informe o seu nome' value={dadosPerfil.Nome || ''} onChange={({target})=>{setDadosPerfil({...dadosPerfil,Nome:target.value})}}/>
                        </DivInput>
                        <DivInput style={{width:'100%',margin:'0'}}>
                            <p>E-mail *</p>
                            <Input placeholder='Informe o seu e-mail' value={dadosPerfil.Email || ''} onChange={({target})=>{setDadosPerfil({...dadosPerfil,Email:target.value})}} />
                        </DivInput>
                        <DivInput style={{width:'100%',margin:'0'}}>
                            <p>Nome para o seu site que será criado pelo MEDX social*</p>
                            <Input placeholder='Dê um nome para o seu blog' value={dadosPerfil.NomeBlog || ''} onChange={({target})=>{AlteraNomeDoBlog(target.value)}} />
                        </DivInput>
                        <DivInput style={{width:'100%',margin:'0'}}>
                            <p>Endereço do seu site que será gerado pelo MEDX Social</p>
                            <div style={{overflow:'hidden',width:'100%',backgroundColor:'lightgray', height:'40px',display:'flex', alignItems:'center', padding:'5px 10px', borderRadius:'4px'}}>
                                <a target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}`}>{`https://social.medx.med.br/${dadosPerfil.EnderecoBlog}`}</a>
                            </div>
                        </DivInput>
                        </div>
                    </DivHeader>
                    <DivInput style={{width:'100%',textAlign:'center'}}>
                        <p>Insira sua logo (1000px largura x 200px altura)</p>
                        <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', margin:'10px 0px 0px 0px'}} >
                            {logoHeader ?
                                <ImgLogo onError={(event)=>loadSVG(event)}
                                    src={URLIMG+dadosPerfil?.LogoHeader?.split('/')[dadosPerfil.LogoHeader.split('/').length - 1] || svgNoImage}
                                    alt=''
                                />
                            :
                                <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                            }
                            <InputFile name='Insira sua logo'
                                onClick={(event)=>enviaDados(event)}
                                mudaImg={setDadosPerfil}
                                imagem={dadosPerfil}
                                campo='LogoHeader'
                                load={logoHeader}
                                concluido={setLogoHeader}

                            />
                        </div>
                    </DivInput>
                    <DivInput style={{width:'100%',textAlign:'center'}}>
                        <p>Insira sua logo versão mobile (smartphone) (240px largura x 70px altura)</p>
                        <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', margin:'10px 0px 0px 0px'}} >
                            {mobileHeaderPerfil ?
                                <ImgLogoMobile onError={(event)=>loadSVG(event)}
                                    src={URLIMG+dadosPerfil?.LogoMobile?.split('/')[dadosPerfil.LogoMobile.split('/').length - 1]?
                                        URLIMG+dadosPerfil?.LogoMobile?.split('/')[dadosPerfil.LogoMobile.split('/').length - 1]
                                    :
                                        svgNoImage}
                                    alt=''
                                />
                            :
                                <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                            }
                            <InputFile name='Inserir logo mobile'
                                onClick={(event)=>enviaDados(event)}
                                mudaImg={setDadosPerfil}
                                imagem={dadosPerfil}
                                campo='LogoMobile'
                                load={mobileHeaderPerfil}
                                concluido={setMobileHeaderPerfil}
                            />
                        </div>
                    </DivInput>
                    <DivInput>
                        <p>Sua Fanpage no facebook</p>
                        <Input placeholder='Insira o link de acesso a sua fanpage do Facebook'
                            defaultValue={dadosPerfil.FanpageFacebook}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,FanpageFacebook:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Seu Instagram</p>
                        <Input placeholder='Insira o link de acesso ao seu Instagram'
                            defaultValue={dadosPerfil.Instagram}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Instagram:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Seu Canal no YouTube</p>
                        <Input placeholder='Insira o link para acesso do seu canal no YouTube'
                            defaultValue={dadosPerfil.Youtube}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Youtube:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>E-mail do Consultório</p>
                        <Input placeholder='Insira um e-mail para contato do consultório'
                            defaultValue={dadosPerfil.EmailConsultorio}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,EmailConsultorio:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Cidade Consultório</p>
                        <Input placeholder='Insira a cidade do consultório'
                            defaultValue={dadosPerfil.City1}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,City1:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Endereço Consultório</p>
                        <Input placeholder='Insira o endereço do consultório'
                            defaultValue={dadosPerfil.Address1}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Address1:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Cidade Consultório2</p>
                        <Input placeholder='Insira a cidade do consultório'
                            defaultValue={dadosPerfil.City2}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,City2:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Endereço Consultório2</p>
                        <Input placeholder='Insira um e-mail para contato do consultório'
                            defaultValue={dadosPerfil.Address2}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Address2:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Whatsapp do Consultório</p>
                        <Input placeholder='Insira um telefone para o whatsapp do consultório'
                            defaultValue={dadosPerfil.Telefone}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Telefone:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Telefone do Consultório</p>
                        <Input placeholder='Insira um telefone para contato do consultório'
                            defaultValue={dadosPerfil.Telefone2}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Telefone2:target.value})}}
                        />
                    </DivInput>


                    <DivInput>
                        <p>Link para integração do seu newsletter</p>
                        <Input  placeholder='Insira o código para o seu NewsLetter'
                            defaultValue={dadosPerfil.NewsLetterLink}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,NewsLetterLink:target.value})}}
                        />
                    </DivInput>

                    <button onClick={(event)=>{event.preventDefault();history.push({pathname:'/app/configpagesblog',state:''})}}>Criar o seu site</button>
                    <DivTituloConfiguracao >
                        <TituloConfiguracao style={{display:'flex', alignItems:'center'}}>
                            Configurações de SEO do site
                            <IconFcInfo data-tip data-for="infoSEO" />
                        </TituloConfiguracao>
                    </DivTituloConfiguracao>
                    <DivInput>
                        <p>Palavras-chave para buscadores (Google)</p>
                        <Input  placeholder='Insira as palavras para otimzar a busca do Google'
                            defaultValue={dadosPerfil.PalavraGoogle}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,PalavraGoogle:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Analitycs</p>
                        <Input placeholder='Insira o codigo do Google Analitycs'
                            defaultValue={dadosPerfil.AnalyticsCode}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,AnalyticsCode:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Descrição do blog</p>
                        <Input placeholder='Insira uma descrição do blog para otimizar a busca do google'
                            defaultValue={dadosPerfil.Description}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,Description:target.value})}}
                        />
                    </DivInput>
                    <DivTituloConfiguracao >
                        <TituloConfiguracao ref={refInitialPage}>
                            Configurações da pagina início <a data-tip data-for="index" target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}/index.html`}><IconGrView/></a>
                        </TituloConfiguracao>
                    </DivTituloConfiguracao>
                    <DivInput>
                        <p>Titulo de Apresentação</p>
                        <Input  placeholder='Insira um titulo para apresentação do seu blog'
                            defaultValue={dadosPerfil.SliderCaption1}
                            maxLength="50"
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderCaption1:target.value})}}
                        />
                    </DivInput>
                    <DivInput>
                        <p>Breve Descrição</p>
                        <Input  placeholder='Insira um breve texto para apresentação do seu site'
                            maxLength="150"
                            defaultValue={dadosPerfil.SliderDescription1}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderDescription1:target.value})}}
                        />
                    </DivInput>
                    <DivInput style={{width:'100%'}}>
                        <p>Texto de apresentação</p>
                        <textarea placeholder='Insira um texto para apresentação do seu blog'
                            value={dadosPerfil.DescriptionWelcome}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,DescriptionWelcome:target.value})}}
                        />
                    </DivInput>
                    <DivImgEButton>
                        <DivInput>
                            <p>Insira uma imagem para a apresentação do seu blog (1900px largura x 550px altura)</p>
                        </DivInput>
                        {apresentacao ?
                            <ImgPaginasBlog  onError={(event)=>loadSVG(event)} src={URLIMG+dadosPerfil?.SliderPicture1?.split('/')[dadosPerfil.SliderPicture1.split('/').length - 1]?URLIMG+dadosPerfil?.SliderPicture1?.split('/')[dadosPerfil.SliderPicture1.split('/').length - 1] : svgNoImage } alt=''/>
                        :
                            <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                        }


                        <InputFile onClick={(event)=>enviaDados(event)}
                            mudaImg={setDadosPerfil}
                            imagem={dadosPerfil}
                            campo='SliderPicture1'
                            load={apresentacao}
                            concluido={setApresentacao}
                            name='Inserir imagem'
                        />

                    </DivImgEButton>

                    <DivTituloConfiguracao>
                        <TituloConfiguracao ref={refFirstPage}>
                            Configurações da primeira página <a data-tip data-for="pagina1" target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}/pagina1.html`}><IconGrView/></a>
                        </TituloConfiguracao>
                    </DivTituloConfiguracao>
                    <DivInput>
                        <p>Nome para aparecer no menu</p>
                        <Input maxLength="50" placeholder='Insira um titulo para apresentação do seu blog' defaultValue={dadosPerfil.SliderCaption2} onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderCaption2:target.value})}} />
                    </DivInput>
                    <DivInput>
                        <p>Breve descrição da primeira página</p>
                        <Input maxLength="150" placeholder='Insira um breve texto para apresentação do seu blog' defaultValue={dadosPerfil.SliderDescription2} onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderDescription2:target.value})}} />
                    </DivInput>
                    <DivInput style={{width:'100%'}}>
                        <p>Texto da primeira página</p>
                        <textarea placeholder='Insira um texto para primeira página do seu site'
                            value={dadosPerfil.DescriptionPage1}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,DescriptionPage1:target.value})}}
                        />
                    </DivInput>
                    <DivImgEButton>
                        <DivInput>
                                <p>Insira uma imagem para a primeira página do seu site (1900px largura x 550px altura)</p>
                        </DivInput>
                        {menu1?
                            <ImgPaginasBlog  onError={(event)=>loadSVG(event)} src={URLIMG+dadosPerfil?.SliderPicture2?.split('/')[dadosPerfil.SliderPicture2.split('/').length -1]?URLIMG+dadosPerfil?.SliderPicture2?.split('/')[dadosPerfil.SliderPicture2.split('/').length -1]:svgNoImage} alt=''/>
                        :
                            <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                        }
                        <InputFile onClick={(event)=>enviaDados(event)}
                            mudaImg={setDadosPerfil}
                            imagem={dadosPerfil}
                            campo='SliderPicture2'
                            load={menu1}
                            concluido={setMenu1}
                            name='Inserir imagem'
                            />
                    </DivImgEButton>
                    <DivTituloConfiguracao>
                        <TituloConfiguracao ref={refSecondPage}>
                                Configurações da segunda página do blog <a data-tip data-for="pagina2" target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}/pagina2.html`}><IconGrView/></a>
                        </TituloConfiguracao>
                    </DivTituloConfiguracao>
                    <DivInput>
                        <p>Nome para aparecer no menu</p>
                        <Input maxLength="50" placeholder='Insira um titulo para apresentação do seu blog' defaultValue={dadosPerfil.SliderCaption3} onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderCaption3:target.value})}} />
                    </DivInput>
                    <DivInput>
                        <p>Breve descrição da segunda página</p>
                        <Input  maxLength="150" placeholder='Insira um breve texto para apresentação do seu blog' defaultValue={dadosPerfil.SliderDescription3} onChange={({target})=>{setDadosPerfil({...dadosPerfil,SliderDescription3:target.value})}} />
                    </DivInput>
                    <DivInput style={{width:'100%'}}>
                        <p>Texto da segunda página</p>
                        <textarea placeholder='Insira um texto para segunda página do seu site'
                            value={dadosPerfil.DescriptionPage2}
                            onChange={({target})=>{setDadosPerfil({...dadosPerfil,DescriptionPage2:target.value})}}
                        />
                    </DivInput>
                    <DivImgEButton>
                        <DivInput>
                                <p>Insira uma imagem para a segunda página do seu site (1900px largura x 550px altura)</p>
                        </DivInput>
                        {menu2?
                            <ImgPaginasBlog  onError={(event)=>loadSVG(event)} src={URLIMG+dadosPerfil?.SliderPicture3?.split('/')[dadosPerfil.SliderPicture3.split('/').length - 1]?URLIMG+dadosPerfil?.SliderPicture3?.split('/')[dadosPerfil.SliderPicture3.split('/').length - 1]:svgNoImage} alt=''/>
                        :
                            <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                        }
                        <InputFile onClick={(event)=>enviaDados(event)}
                            mudaImg={setDadosPerfil}
                            imagem={dadosPerfil}
                            campo='SliderPicture3'
                            load={menu2}
                            concluido={setMenu2}
                            name='Inserir imagem'
                        />
                    </DivImgEButton>
                    <DivTituloConfiguracao>
                        <TituloConfiguracao ref={refProfileInfo}>
                                Configurações informações de perfil <a data-tip data-for="sobremim" target='_blank' rel='noopener noreferrer' href={`https://social.medx.med.br/sites/${dadosPerfil.EnderecoBlog}/sobremim.html`}><IconGrView/></a>
                        </TituloConfiguracao>
                    </DivTituloConfiguracao>
                    <DivInput style={{width:'100%'}}>
                        <p>Seu curriculo (página sobre mim) </p>
                        <textarea value={dadosPerfil.Curriculo} onChange={({target})=>{setDadosPerfil({...dadosPerfil,Curriculo:target.value})}} />
                    </DivInput>
                    <DivImgEButton>
                        <DivInput>
                                <p>Inserir uma capa para página de perfil (1200px largura x 500px altura)</p>
                        </DivInput>
                        {headerPerfil?
                            <DivImgLogoPerfil  onError={(event)=>loadSVG(event)} src={URLIMG+dadosPerfil?.Cover?.split('/')[dadosPerfil.Cover.split('/').length - 1]?URLIMG+dadosPerfil?.Cover?.split('/')[dadosPerfil.Cover.split('/').length - 1]:svgNoImage} alt=''/>
                        :
                            <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                        }
                        <InputFile onClick={(event)=>enviaDados(event)}
                            mudaImg={setDadosPerfil}
                            imagem={dadosPerfil}
                            campo='Cover'
                            load={headerPerfil}
                            concluido={setHeaderPerfil}
                            name='Inserir imagem'
                            />
                    </DivImgEButton>
                </Form>

*/}
